import { render, staticRenderFns } from "./BucketListPage.vue?vue&type=template&id=95f62a7a&scoped=true"
import script from "./BucketListPage.vue?vue&type=script&lang=js"
export * from "./BucketListPage.vue?vue&type=script&lang=js"
import style0 from "./BucketListPage.vue?vue&type=style&index=0&id=95f62a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f62a7a",
  null
  
)

export default component.exports